import { NameAddrHeader } from '@wui/jssip'

import { parseRemotePartyId } from './parse-remote-party-id'

export const parseNameAddrDisplayName = (header: string): string | undefined => {
  const fromQuotes = parseRemotePartyId(header)
  if (fromQuotes) {
    return fromQuotes
  }

  try {
    const parsed = NameAddrHeader.parse(header) as unknown as NameAddrHeader
    return parsed.display_name || undefined
  } catch {
    return undefined
  }
}
